import { render, staticRenderFns } from "./transfer-payment.vue?vue&type=template&id=e63bdf4a&scoped=true"
import script from "./transfer-payment.vue?vue&type=script&lang=ts"
export * from "./transfer-payment.vue?vue&type=script&lang=ts"
import style0 from "./transfer-payment.vue?vue&type=style&index=0&id=e63bdf4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63bdf4a",
  null
  
)

export default component.exports